.groupWrapper {
  margin-bottom: 8px;
}

.groupHeadingWrapper {
  /* Remove button defaults */
  border: 0;
  background-color: transparent;

  display: flex;
  width: 100%;
  align-items: center;
  cursor: pointer;
  gap: var(--spacing-s);
  color: light-dark(var(--brand-grey-50), var(--brand-grey-200));
  padding: 4px 15px;
  border-radius: 3px;
  transition: background-color 0.2s ease;
}

.groupHeadingWrapper:hover {
  background-color: light-dark(var(--brand-blue-500), var(--brand-grey-600));
}

.groupHeadingText {
  flex-grow: 1;
  margin: 0;
  font-size: var(--font-size-s);
  font-weight: 600;
  font-variant: small-caps;
  color: light-dark(var(--brand-grey-50), var(--brand-grey-100));
  text-transform: uppercase;
  text-align: left;
  letter-spacing: 1px;
  user-select: none;
}

.chevron {
  margin-left: auto;
  margin-right: var(--spacing-s);
  transition: transform 0.3s ease;
  transform: rotate(-90deg);

  svg {
    width: 12px;
  }
}

.chevron.expanded {
  transform: rotate(0deg);
}

.groupContent {
  overflow: hidden;
  transition:
    max-height 0.3s ease,
    opacity 0.3s ease,
    transform 0.3s ease;
}

.groupContent.expanded {
  max-height: 500px;
  opacity: 1;
  transform: translateY(0);
}

.groupContent.collapsed {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
}

.navCollapsed .groupContent {
  display: none;
}

/* Remove hover styles and padding when nav is collapsed */
.navCollapsed .groupHeadingWrapper {
  padding: 0;
}

/* Increase spacing between icons when nav is collapsed */
.navCollapsed .groupWrapper {
  margin-bottom: 16px;
}
